import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { CustomReportDesignStateClass } from "../interfaces/ReportClasses";
import fetchAPI from "../../../common/fetchAPI";
import fetchTimeliveAPI from "../../../common/fetchTimeliveAPI";
// import { createCustomReportDesignInitials } from "../interfaces/ReportClasses";


const initialState: CustomReportDesignStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    accountReportList: [],
    accountReportColumnList:[]
};

interface IThunkApi {
    state: {
        customReportDesign: CustomReportDesignStateClass
    }
};

export const getAllDataInSingleRequestAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/getAllDataInSingleRequest",
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/V2/Reports/AllDataInSingleRequest?AccountReportId=`+arg, 'Get', '', true);
            const json = response.json();
            return json;
        }
    )

export const getAccountEmployeeTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "EmployeeTypes/v2/getAccountEmployeeType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

//this should be remove
export const getAccountReportByAccountReportIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/getAccountReportByAccountReportId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Reports/AccountReportById/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
    
export const GetSystemReportDataSourceFieldBySystemReportDataSourceIdAndAccountReportIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/GetSystemReportDataSourceFieldBySystemReportDataSourceIdAndAccountReportId",
        async (arg, thunkApi) => {
            const {AccountReportId,SystemReportDataSourceId} = arg
            const response = await fetchAPI("api/v2/Reports/ReportColumn/" + AccountReportId + "/" + SystemReportDataSourceId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const IsAccountReportGroupExistAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/IsAccountReportGroupExist",
        async (arg, thunkApi) => {
            const { AccountReportId, SystemReportDataSourceFieldId } = arg
            const response = await fetchAPI("api/v2/Reports/ReportGroupExist/" + AccountReportId + "/" + SystemReportDataSourceFieldId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const addAccountReportAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/addAccountReport",
        async (arg, thunkApi) => {
            const { AccountReportId, currentFieldsData } = arg;
            const response = await fetchAPI("api/v2/Reports/" + AccountReportId, "POST", currentFieldsData, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const addReportOrdersAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/addReportOrders",
        async (arg, thunkApi) => {

            // const response = await fetchAPI("api/EmployeeTypes/","POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Reports/ReportOrders/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateAccountEmployeeTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "EmployeeTypes/v2/updateAccountEmployeeType",
        async (arg, thunkApi) => {
            const { AccountEmployeeTypeId, ...argWithoutId } = arg;
            //const response = await fetchAPI("api/EmployeeTypes/"+AccountEmployeeTypeId,"POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes/" + AccountEmployeeTypeId, "PUT", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const deleteAccountEmployeeTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "EmployeeTypes/v2/deleteAccountEmployeeType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const DeleteSelectedAccountEmployeeTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "EmployeeTypes/v2/DeleteSelectedAccountEmployeeType",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/EmployeeTypes/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

export const SystemReportFileType = createAsyncThunk
    <any, void, IThunkApi>
    (
        "api/SystemReportFileType",
        async (_, thunkApi) => {
            const response = await fetchTimeliveAPI('api/SystemReportFileType', 'GET', '', true);
            const json = await response.json();
            return json;

        }
    )

export const SystemReportDateRange = createAsyncThunk
    <any, void, IThunkApi>
    (
        "api/SystemReportDateRange",
        async (_, thunkApi) => {
            const response = await fetchTimeliveAPI('api/SystemReportDateRange', 'GET', '', true);
            const json = await response.json();
            return json;

        }
    )

export const SystemReportDeliveryFrequency = createAsyncThunk
    <any, void, IThunkApi>
    (
        "api/SystemReportDeliveryFrequency",
        async (_, thunkApi) => {
            const response = await fetchTimeliveAPI('api/SystemReportDeliveryFrequency', 'GET', '', true);
            const json = await response.json();
            return json;

        }
    )

export const SystemReportDeliveryTime = createAsyncThunk
    <any, void, IThunkApi>
    (
        "api/SystemReportDeliveryTime",
        async (_, thunkApi) => {
            const response = await fetchTimeliveAPI('api/SystemReportDeliveryTime', 'GET', '', true);
            const json = await response.json();
            return json;

        }
    )

const customReportDesignSlice = createSlice({
    name: "customReportDesign",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkboxState: (state, action) => {
            const { SystemReportDataSourceFieldId, SystemReportDataSourceField, Checked } = action.payload;
            const currentindex = state.accountReportColumnList.findIndex((item: any) => item.SystemReportDataSourceFieldId == SystemReportDataSourceFieldId);
            const newArray = [...state.accountReportColumnList];
            newArray[currentindex] = { ...newArray[currentindex], [SystemReportDataSourceField]: Checked };
            state.accountReportColumnList = newArray;
        },
        changeState: (state, action) => {
            const { SystemReportDataSourceFieldId, SystemReportDataSourceField, Value } = action.payload;
            const currentindex = state.accountReportColumnList.findIndex((item: any) => item.SystemReportDataSourceFieldId == SystemReportDataSourceFieldId);
            const newArray = [...state.accountReportColumnList];
            newArray[currentindex] = { ...newArray[currentindex], [SystemReportDataSourceField]: Value };
            state.accountReportColumnList = newArray;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllDataInSingleRequestAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAllDataInSingleRequestAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;

                if (Object.keys(payload.AccountReport).length === 0) {
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.AccountReport[0];
                }
            })
            .addCase(getAllDataInSingleRequestAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getAccountEmployeeTypeAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {

                state.status = "idle";
                //state.employeeTypeList = payload;
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    // state.employeeTypeList = [];
                } else {
                    // state.employeeTypeList = payload.Data;
                    // state.employeeTypeList.map((item: any) => {
                    //     item.isSelected = 0
                    // });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = "failed";
            })

            .addCase(GetSystemReportDataSourceFieldBySystemReportDataSourceIdAndAccountReportIdAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(GetSystemReportDataSourceFieldBySystemReportDataSourceIdAndAccountReportIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.accountReportColumnList = [];
                } else {
                    state.accountReportColumnList = payload.Data;
                }
                state.isReload = false;
                state.isLoading = false;

            })
            .addCase(GetSystemReportDataSourceFieldBySystemReportDataSourceIdAndAccountReportIdAsync.rejected, (state) => {
                state.status = "failed";
            })

            //this should be remove
            .addCase(getAccountReportByAccountReportIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountReportByAccountReportIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                //state.selectedRecord = payload[0];
            })
            .addCase(getAccountReportByAccountReportIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addAccountReportAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountReportAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(addAccountReportAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addReportOrdersAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addReportOrdersAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(addReportOrdersAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountEmployeeTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountEmployeeTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(DeleteSelectedAccountEmployeeTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(SystemReportFileType.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(SystemReportFileType.fulfilled, (state, action) => {
                state.status = 'idle';
            })
            .addCase(SystemReportFileType.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(SystemReportDateRange.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(SystemReportDateRange.fulfilled, (state, action) => {
                state.status = 'idle';
            })
            .addCase(SystemReportDateRange.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(SystemReportDeliveryFrequency.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(SystemReportDeliveryFrequency.fulfilled, (state, action) => {
                state.status = 'idle';
            })
            .addCase(SystemReportDeliveryFrequency.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(SystemReportDeliveryTime.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(SystemReportDeliveryTime.fulfilled, (state, action) => {
                state.status = 'idle';
            })
            .addCase(SystemReportDeliveryTime.rejected, (state) => {
                state.status = 'failed';
            })
    }
});

export const { resetSelectedRecordObjectInState, checkboxState, changeState } = customReportDesignSlice.actions
export const CustomReportDesignState = (state: RootState) => state.customReportDesign
export default customReportDesignSlice.reducer


